import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { radioFilterId, RadioFilter, TimeRangeFilter } from '../../filters';
import { useSummarizedFilterStateById } from '../../../stores/FilterStateStore';
import { LAYOUT_WIDTH } from '../../page-framework/panel-container/PanelContainer';

import {
    RadioStatusPanel,
    RadioChannelUtilizationPanel,
    RadioRetryRatePanel,
    RadioErrorFramesPanel,
    RadioManagementFramesPanel,
    RadioPropertiesPanel,
    RadioBssidListPanel,
} from '../../panels';

export const pageId = 'radio-detail';

export default function RadioDetailPage() {
    const [summarized] = useSummarizedFilterStateById(radioFilterId);
    const title = summarized?.value;

    return (
        <Page id={pageId}>
            <PageHeader title={title}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <RadioFilter required />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <RadioStatusPanel width={LAYOUT_WIDTH.FULL} title={t`Status`} />
                <RadioChannelUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`Channel Utilization`} />
                <RadioRetryRatePanel width={LAYOUT_WIDTH.HALF} title={t`Retry Rate`} />
                <RadioErrorFramesPanel width={LAYOUT_WIDTH.HALF} title={t`Received Error Frame Rate`} />
                <RadioManagementFramesPanel width={LAYOUT_WIDTH.HALF} title={t`Transmitted Management Frames`} />
                <RadioPropertiesPanel width={LAYOUT_WIDTH.HALF} title={t`Properties`} />
                <RadioBssidListPanel width={LAYOUT_WIDTH.HALF} title={t`BSSIDs`} />
            </PanelContainer>
        </Page>
    );
}
